import { supabase } from '@/features/sistema/services/supabaseClient';

const COMMENT_LIKES_TABLE = 'app_comment_likes';

export type CommentLikeRecord = {
  comment_id: string;
  usuario_id: string;
  created_at: string;
};

export async function listLikesByComments(commentIds: string[]) {
  if (!commentIds?.length) {
    return [] as CommentLikeRecord[];
  }

  const { data, error } = await supabase
    .from(COMMENT_LIKES_TABLE)
    .select('*')
    .in('comment_id', commentIds);

  if (error) {
    throw error;
  }

  return (data ?? []) as CommentLikeRecord[];
}

export async function likeComment(commentId: string, usuarioId: string) {
  if (!commentId || !usuarioId) return;

  const { error } = await supabase
    .from(COMMENT_LIKES_TABLE)
    .upsert(
      {
        comment_id: commentId,
        usuario_id: usuarioId,
      },
      { onConflict: 'comment_id,usuario_id' },
    );

  if (error) {
    throw error;
  }
}

export async function unlikeComment(commentId: string, usuarioId: string) {
  if (!commentId || !usuarioId) return;

  const { error } = await supabase
    .from(COMMENT_LIKES_TABLE)
    .delete()
    .eq('comment_id', commentId)
    .eq('usuario_id', usuarioId);

  if (error) {
    throw error;
  }
}

export async function hasUserLikedComment(commentId: string, usuarioId: string) {
  if (!commentId || !usuarioId) return false;

  const { data, error } = await supabase
    .from(COMMENT_LIKES_TABLE)
    .select('comment_id')
    .eq('comment_id', commentId)
    .eq('usuario_id', usuarioId)
    .limit(1);

  if (error) {
    throw error;
  }

  return Array.isArray(data) && data.length > 0;
}

